import DeviceGroupStats from './DeviceGroupStats.vue'

export default DeviceGroupStats;
